function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 42,
  cy: 42,
  r: 42,
  fill: "#FCEEF1"
});

var _ref3 = /*#__PURE__*/React.createElement("line", {
  x1: 2,
  y1: -2,
  x2: 41.0738,
  y2: -2,
  transform: "matrix(-0.717577 0.696479 -0.717577 -0.696479 55.9087 25.5)",
  stroke: "#E03E64",
  strokeWidth: 4,
  strokeLinecap: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("line", {
  x1: 2,
  y1: -2,
  x2: 41.0738,
  y2: -2,
  transform: "matrix(0.717577 0.696479 0.717577 -0.696479 28.0913 25.5)",
  stroke: "#E03E64",
  strokeWidth: 4,
  strokeLinecap: "round"
});

var SvgStatusFailed = function SvgStatusFailed(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStatusFailed, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/status-failed.a6881f7e.svg";
export { ForwardRef as ReactComponent };